import { render } from "./MainDetalProduct.vue?vue&type=template&id=14b26c5d&scoped=true"
import script from "./MainDetalProduct.vue?vue&type=script&lang=js"
export * from "./MainDetalProduct.vue?vue&type=script&lang=js"

import "./MainDetalProduct.vue?vue&type=style&index=0&id=14b26c5d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b26c5d"]])

export default __exports__